import { render, staticRenderFns } from "./AddCustom.vue?vue&type=template&id=f39d9694"
import script from "./AddCustom.vue?vue&type=script&lang=js"
export * from "./AddCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports